// Blue + white palette matching Trading Secret. Use COLORS[i % COLORS.length].
export const COLORS = ['#00b4ff', '#0090cc', '#0077b6', '#0a85c2', '#005f8f', '#0aa5e6', '#006da3', '#0099dd'];
